module.exports = function getResource(label, vars = []) {
    const resources = { view12More: 'View 12 More' };
    return resources[label];
};
